import { Component } from '@angular/core';

@Component({
    selector: 'app-accept-invitation',
    templateUrl: './accept-invitation.component.html',
    styleUrls: ['./accept-invitation.component.css'],
    standalone: false
})
export class AcceptInvitationComponent {

}
